import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
   selector: 'app-share-download-folder',
   templateUrl: 'share-download-folder.component.html',
   styleUrls: ['../../download-folder/download-folder.component.css']
})
export class ShareDownloadFolderComponent implements OnInit {
   private id: string;
   private timer: any;
   progress = 0;
   error: string;
   @ViewChild('cancel') cancel: MatButton;

   constructor(private dialogRef: MatDialogRef<ShareDownloadFolderComponent>, @Inject(MAT_DIALOG_DATA) private data: any) {}

   ngOnInit(): void {
      const that = this;
      this.data.service.post('/share-public/folder/download?id=' + this.data.id, {})
          .subscribe(data => {
             that.id = data.nodeRef;
             that.timer = setInterval(() => {
                that.checkStatus();
             }, 500);
          });
   }

   private checkStatus(): void {
      const that = this;
      this.data.service.get('/share-public/download/status?id=' + this.id)
          .subscribe(data => {
             if (data.done === data.total && data.status === 'DONE' && data.filesAdded === data.totalFiles) {
                clearInterval(that.timer);
                that.progress = 100;
                that.cancel.disabled = true;
                location.href = that.data.service.url + '/share-public/download?id=' + that.id
                   + '&name=' + encodeURIComponent(that.data.name + '.zip');
                setTimeout(() => {
                   that.cleanAndClose(this.cancel);
                }, 500);
             } else {
                that.progress = Math.floor(data.done * 100 / data.total);
             }
          }, error => {
             that.error = error;
             clearInterval(that.timer);
             that.delete();
          });
   }

   cleanAndClose(cancel: MatButton): void {
      cancel.disabled = true;
      if (this.id) {
         const that = this;
         this.delete().subscribe(() => { that.dialogRef.close(); }, () => { that.dialogRef.close(); });
      } else {
         this.dialogRef.close();
      }
   }

   private delete(): Observable<any> {
      return this.data.service.delete('/share-public/download?id=' + this.id);
   }
}
